export function formatBICInput() {
  const formatBicInputs = document.querySelectorAll(".bic-input");

  for (let i = 0; i < formatBicInputs.length; i++) {
    formatBicInputs[i].addEventListener("input", function (e) {
      let target = e.target;

      target.value = target.value.toUpperCase();

      target.value = target.value.replace(/[^\dA-Z]/g, "").trim();
    });
  }
}
